import {Club} from "./custom";
import {User} from "../user/UserContext";
import {countriesConverter} from "./helpers";

type StringEnum = {
    [index in string | number]: any;
}

interface moneyMaxCalcProps {
    time?: number
    s: any,
    currency?: number,
    club?: Club
    addTax: boolean
    taxCode: "standard" | "ebook" | "zero" | undefined,
    user?: User
}

const fieldTranslation = {
    prename: "Vorname",
    lastname: "Nachname",
    phone: "Telefon",
    email: "E-Mail",
    pricenm: "Preis (kein Mitglied)",
    price: "Preis",
    olderthan: "Älter als",
    youngerthan: "Jünger als",
    street: "Straße",
    street_number: "Hausnummer",
    street_number_add: "Hausnummern-Zusatz",
    city: "Stadt",
    postal_code: "PLZ",
    postalCode: "PLZ",
    route: "Straße",
    locality: "Ort",
    birthdate: "Geburtsdatum",
    deathdate: "Sterbedatum",
    member: "Mitglied",
    memberStatus: "Mitglieds-Status",
    memberStatusNew: "Mitglieds-Status",
    memberStatusDescription: "Positionsbezeichnung",
    bank: "Banküberweisung",
    card: "Kreditkartenzahlung",
    sofort: "EPS-Überweisung",
    brig: "Bankbuchung",
    sepa_debit: "SEPA Lastschrift Einzug",
    voucher: "Gutschein",
    sepm_debit: "SEPA Lastschrift Einzug",
    titlesAnte: "Titel vorangestellt",
    titlesPost: "Titel nachgestellt",
    titlesJob: "Berufsbezeichnung",
    svn: "Sozialvers.-Nr.",
    letterAddressation: "Briefanrede",
    companyName: "Firmenname",
    companyPosition: "Position in Firma",
    vatID: "UID-Nummer",
    companyRegNr: "FB-Nummer",
    phoneAdd: "Telefon 2",
    source: "Erfassungs-Quelle",
    sex: "Geschlecht",
    IDLegacy: "vorherige ID",
    zvrNr: "ZVR-Nr",
    name: "Name",
    gender: "Geschlecht",
    minparts: "Minimale Teilnehmer",
    maxparts: "Maximale Teilnehmer",
    priceInput: "Preis (€)",
    pricenmInput: "Preis kein Mitglied (€)",
    bookingStart: "Buchbar ab",
    bookingEnd: "Buchbar bis",
    bookingStopStart: "Buchbar-Stop Start",
    bookingStopEnd: "Buchbar-Stop Ende",
    dueDate: "Fällig am",
    active: "Aktiv",
    allBookingStart: "Für neue Mitglieder buchbar ab",
    showStart: "Anzeigen ab",
    showEnd: "Anzeigen bis",
    yearAllowedLeft: "Jahrgänge ab inklusive (JJJJ)",
    yearAllowedRight: "Jahrgänge bis inklusive (JJJJ)",
    membersOnly: "Mitgliedschaft erforderlich?",
    audience: "Zielgruppe",
    rolesAllowed: "Definierende Rollen",
    tags: "Tags",
    description: "Beschreibung",
    information: "Information",
    trainerBecause: "Trainer weil",
    trainerSince: "Trainer seit",
    iLike: "Der Turnverein gefällt mir",
    titleDetail: "Detailierter Titel",
    titleDisplay: "Angezeigter Titel",
    institute: "Ausbildungsinstitut",
    location: "Ausbildungsort",
    file: "Datei",
    shortName: "Kurzname",
    showLogo: "Zeige Logo beim Login",
    showDiscounts: "Ermögliche die Eingabe von Rabattcodes",
    iban: "IBAN",
    bic: "BIC",
    bankname: "Name der Bank",
    dateFounded: "Gründungsdatum",
    sendReminders: "System-E-Mails senden",
    sendPaymentReminders: "Zahlungserinnerungen senden",
    paymentDueDate: "Fällig ab",
    paymentMethods: "Bezahlmethoden",
    memberStates: "Mitgliedsstatuscodes",
    enableOnlineConferences: "Online Treffen",
    trainersAllowed: "erweiterter Trainerzugriff",
    enableMedia: "Medienabschnitt",
    downloadCertificate: "Zertifikat herunterladen",
    downloadCertificateID: "Standard-Zertifikatsvorlage",
    eventBookingPrice: "Einzeltermin-Preis",
    cancellationMode: "Stornierungsmodus",
    bookingMode: "Buchungsmodus",

    type: "Typ",
    label: "Bezeichnung",
    tag: "Tag",
    showIfNonExistent: "Zeige immer an",
    editable: "Bearbeitungsmodus",
    required: "Erforderlich",
    showInAMS: "Zeige in Mitgliedskartenscan-Kiosk",
    additionalFields: "Zusätzliche Felder",
    props: "Weitere Daten",

    noMembership: "Keine Mitgliedschaft im Verein",
    boardMembershipFeeMode: "Mitgliedsbeitr. fällig für",
    roomBookingViewMode: "Raumbuchungsmodus",
    showMembershipCard: "Zeige Mitgliedskarte",
    showMediaMode: "Lege die Sichbarkeit von Medien fest",
    svnRequired: "Sozialversicherungsnummer benötigt",
    hideCapacity: "Anzahl freier Plätze von Kursen ausblenden",
    registerAusserordentlichesMitgliedText: "Information für die Anmeldung außerordentlicher Mitglieder",
    registerOrdentlichesMitgliedText: "Information für die Anmeldung ordentlicher Mitglieder",
    registerUnterstuetzendesMitgliedText: "Information für die Anmeldung unterstützender Mitglieder",
    paymentReminderInterval: "Intervall der Zahlungserinnerungen (in Tagen)",

    color: "Hintergrundfarbe",
    fontColor: "Textfarbe",
    fontColorInverse: "Invertierte Textfarbe",

    dataprotectionLink: "Link zur Datenschutzerklärung",
    agbsLink: "Link zu den AGBs",
    statutenLink: "Link zu den Statuten",
    facebook: "Link der Neuigkeiten-Seite",

    invoiceDate: "Rechnungsdatum",
    invoiceNumber: "Rechnungsnummer",
    comment: "Kommentar",
    contact: "Kontakt",
    contactID: "Kontakt",
    defaultInvoiceTemplateID: "Standard Rechnungsvorlage",
    invoiceTemplateID: "Rechnungvorlage",
    newsletterTemplateID: "Newsletter-Vorlage",

    showTax: "USt ausweisen",
    showAmount: "Mengen anzeigen",
    sendInvoicePDFs: "Sende Rechnung bei Kursbuchung",
    invoice_rows: "Rechnungszeilen",

    WaitlistConfirmationText: "Text von E-Mails bei Übernahme von Wartelisten",
    CourseConfirmationText: "Text bei Kursbuchungsbestätigungen",
    PaymentReminderText: "Text für Zahlungserinnerungen",
    EmailGreetings: "E-Mail Grußzeile",
    EmailSignature: "E-Mail Signatur",
    childID: "Personennummer",
    course_parts_ID: "Kursteilnahme-Nummer",
    amount: "Menge",
    taxRate: "Steuersatz",
    paymentStatus: "Zahlungsstatus",
    invoice_ID: "Rechnungsnummer",
    additionalText: "Zusätzlicher Text",
    coursePaymentModel_ID: "Nummer der Zahlungsweise",
    Entry_ID: "Eintrags-Nummer",
    Group_ID: "Gruppen-Nummer",
    zvrNumber: "ZVR-Nummer",
    Kontaktname: "Kontakt: Name",
    Kontakthausnummer: "Kontakt: Hausnummer",
    KontaktPLZ: "Kontakt: PLZ",
    Kontaktstrasse: "Kontakt: Straße",
    Kontaktort: "Kontakt: Ort",
    KontaktLand: "Kontakt: Land",
    KontaktUID: "Kontakt: UID",
};

class ConstsClass {
    placeHolders: Record<string, string | number> = {
        svn: "1234010101",
        email: "max@mustermann.at",
        prename: "Max",
        lastname: "Mustermann",
        phone: "+43 664 1234567",
        companyName: "Muster GmbH",
        vatID: "ATU12345678",
        companyRegNr: "123456a",
        name: "Allgemeiner Musterverein",
        website: "www.musterverein.at",
        zvrNr: 12456789,
        iban: "AT12 3456 7890 1234 5678"
    };
    weekdayNames = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];


    /*memberStates = {
        0: "Nichtmitglied",
        1: "ordentliches Mitglied",
        2: "außerordentliches Mitglied",
        3: "unterstützendes Mitglied",

        4: "befreites Mitglied",
        5: "Zeugwart Stellvertretung",
        6: "Zeugwart",

        7: "Sportliche Leitung Stellvertretung",
        8: "Sportliche Leitung",
        9: "Kassier Stellvertretung",
        10: "Kassier",
        11: "Schriftführer Stellvertretung",
        12: "Schriftführer",
        13: "Obfrau/Obmann Stellvertretung",
        14: "Obfrau/Obmann",

        40: "ruhendes Mitglied",
        41: "Trainer",

        //100: "Vorstand"
    };
    memberStatesShort = Object.keys(this.memberStates).reduce((obj, k) => ({...obj, [k]: this.memberStates[k].split(" ").map(u => u[0]).join(".")}), {});*/
    kontenKinds = {0: "Allgemeines Konto", 1: "Bank", 5: "Kundenkonto", /*2: "Kontenklasse", 3: "Kostenträger"*/};
    buchSymbole = {
        AR: "Ausgangsrechnung",
        ER: "Eingangsrechnung",
        BB: "Bilanzbuchung",
        BU: "Buchungsanweisung",
        EB: "Eröffnungsbilanz",
        KA: "Kassa",
        SO: "Sonstige Belege",
        BK: "Bank",
        LG: "Lohn/Gehalt",
        UE: "Saldenübernahme",
        GU: "Ausgangsgutschrift",
        EG: "Eingangsgutschrift"
    };
    sexMap = {male: "männlich", fem: "weiblich"};
    translate = (name: keyof typeof fieldTranslation | any) => !!name ? fieldTranslation[name as keyof typeof fieldTranslation] || ((name[0] || "").toUpperCase() + name.substr(1)) : "";


    money = new Intl.NumberFormat('de-AT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    moneyAlt = new Intl.NumberFormat('de-AT', {
        style: 'currency',
        currency: 'ATS',
        minimumFractionDigits: 2
    });
    PHASE: string;
    API_PREFIX: string;
    user_id_prod: any;


    constructor() {
        this.PHASE = process.env.NODE_ENV;
        this.f = this.f.bind(this);
        let f = this.f;

        this.API_PREFIX = "/api";//f("", "/api");
    }

    f<T = any>(dev: T, prod: T, user_id = -1) {
        if (process.env.NODE_ENV === "development" || (user_id !== -1 && this.user_id_prod.indexOf(user_id) < 0)) {
            return dev
        }
        return prod
    }

    moneyMaxCalc = ({s, currency = 0, club, addTax = false, taxCode = "standard", time = 0, user}: moneyMaxCalcProps) => {
        const nowVatRegistered = !!club?.vatRegisteredSince && (club?.vatRegisteredSince < (time || (new Date().getTime() / 1000)))
        let taxRate = null;
        if (nowVatRegistered && addTax) {

            let b2c_rate = 20;
            if (taxCode === "zero") {
                b2c_rate = 0
            } else if (user?.country?.toUpperCase() !== "AT" && EUCountries.includes(user?.country?.toUpperCase() ?? "")) {
                b2c_rate = (tax_rates[taxCode] || {})[user?.country?.toUpperCase() ?? ""]
                if (b2c_rate === undefined) {
                    b2c_rate = tax_rates.standard[user?.country?.toUpperCase() ?? ""]
                }
            }
            if (!!user && (!Consts.EUCountries.includes(user?.country?.toUpperCase() || "AT") || (user?.country !== "AT" && ((user?.data || {})["USt-Id-Nr"] || "") != ""))) {
                taxRate = 0
            } else {
                s = s * (100+b2c_rate)/100;
                taxRate = b2c_rate
            }
            console.log({taxCode, b2c_rate})
        }
        return this.moneyMax(s, currency, taxRate, club, time)
    };

    moneyMax = (s: any, currency = 0, taxRate: number | null = null, club?: Club, time: number = 0) => {
        const nowVatRegistered = !!club?.vatRegisteredSince && (club?.vatRegisteredSince < (time || (new Date().getTime() / 1000)))
        return (currency === 0 ? this.money.format(s).replace(".", " ") : this.moneyAlt.format(s).replace(".", " ")) + (taxRate !== null && taxRate !== undefined && nowVatRegistered && s != 0 ? " (inkl. " + taxRate + "% USt" + (taxRate === 0 ? ", Reverse Charge)" : ")") : "")
    };

    telCommonCountryCodes = [
        43,


        387,
        386,
        385,
        384,
        383,
        382,
        381,
        380,
        212,


        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,

        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,

        7,

        420,
        421,
        423,

        40,
        41,
        44,
        45,
        46,
        47,
        48,
        49,

        30,
        31,
        32,
        33,
        34,
        36,
        39,

        353,
        90,
    ];

    isNumber = function (value: any) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    };

    phoneNormalise(s: any) {
        if (this.isNumber(s) || !s)
            return s;

        s = s.replaceAll(" ", "");
        if (s === "")
            return 0;
        s = s.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");

        if (s.length < 5)
            return parseInt(s);

        if (s[0] === "+")
            s = s.substr(1);

        s = s.replace(/^0+/, "");

        if (!(this.telCommonCountryCodes.indexOf(parseInt(s.substr(0, 2))) > -1 || this.telCommonCountryCodes.indexOf(parseInt(s.substr(0, 3))) > -1)) {
            s = "43 " + s;
        } else {
            s = s.substr(0, 2) + " " + s.substr(2)
        }
        const cell = parseInt(s.substr(3, 3));
        let dist = 7;
        if (650 <= cell && cell <= 699) {
            dist = 6;
        }
        return "+" + s.substr(0, dist) + " " + s.substr(dist)
    }

    countries = [
        "AT", "DE",
        ...[
            "CH", "IT",
            "FR", "GB", "BE", "NL", "IE", "PL", "ES", "FI", "CZ", "SE", "NO", "HU", "SI", "SK", "SG", "DK", "EE", "LV", "LT", "MT", "PT", "GR", "RO", "BG", "HR", "BH", "RS", "TR",
            "CY", "LU", "LI", "CA", "US", "UA", "RU", "AL", "MK", "MD", "RKS", "MNE"
        ].sort()
    ];
    countriesToSelect = this.countries.map(a => ({label: countriesConverter.getName(a, "de"), value: a})).filter(a => a.label).sort((a, b) => a.label.replace("Ö", "O") < b.label.replace("Ö", "O") ? -1 : 1);
    paymentMethodsMap = {
        sepa: "SEPA Lastschrift",
        sepm: "SEPA Lastschrift",
        card: "Kreditkarte",
        sofort: 'EPS-Überweisung',
        bank: 'Banküberweisung',
        voucher: "Gutschein",
    }
    attendanceExprMap: StringEnum = {
        "-2": "noch nicht Teilnehmer",
        "-1": "ohne Buch. anw.",
        "0": "abwesend (auto)",
        "1": "anwesend",
        "2": "abwesend (man)",
        "3": "entschuldigt",
        "10": "anwesend (selbst)",
    };
    numOfAttendanceStatuses = 4;

    EUCountries = [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DK",
        "EE",
        "FI",
        "HR",
        "FR",
        "DE",
        "GR",
        "HU",
        "IE",
        "IT",
        "LV",
        "LT",
        "LU",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SK",
        "SI",
        "ES",
        "SE",
    ]

    CLUB_ATV_ST_VALENTIN = 0
    CLUB_WELSER_TURNVEREIN = 2
    CLUB_BEWEGUNGSWELT = 3
    CLUB_ATV_ANDORF = 4
    CLUB_TV_TAUFKIRCHEN = 5
    CLUB_TV_SCHWANENSTADT = 6
    CLUB_TV_MONDSEE = 7
    CLUB_ITV_INNSBRUCK = 8
    CLUB_OETB_LINZ = 9
    CLUB_OETB_AUSSEERLAND = 10
    CLUB_TV_STEYR = 11
    CLUB_ATV_SCHWERTBERG = 12
    CLUB_GUN_CLUB_LUSTENAU = 13
    CLUB_ATV_ANDORF_SCHWIMMEN = 14
    CLUB_VBC_STEYR = 15
    CLUB_OETB_PICHLING = 16
    CLUB_ATV_WEYER = 18
    CLUB_KUNSTTURNEN_TERNITZ = 19
    CLUB_BV_NEWTON = 20
    CLUB_OETB_SCHAERDING = 21
    CLUB_TV_SALZBURG = 22
    CLUB_ARTANDDANCE_CENTER = 23
    CLUB_OETB_BRUNNENTHAL = 24
    CLUB_ARTANDDANCE_CONNECTION = 25
    CLUB_TURNSPORT_TIROL = 26
    CLUB_TANZSTUDIOS = 31
    CLUB_KUNSTTURNEN_MATTERSBURG = 30
    CLUB_BV_NEWTON_GRAZ = 35
}

const EUCountries = [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "HR",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
];

const tax_rates: {standard: {[cc: string]: number}, ebook: {[cc: string]: number}} = {
    "standard": {
        "BE": 21,
        "BG": 20,
        "DK": 25,
        "DE": 19,
        "EE": 24,
        "FI": 25.5,
        "FR": 20,
        "GR": 24,
        "IE": 23,
        "IT": 22,
        "HR": 25,
        "LV": 21,
        "LT": 21,
        "LU": 17,
        "MT": 18,
        "NL": 21,
        "NI": 20,
        "AT": 20,
        "PL": 23,
        "PT": 23,
        "RO": 19,
        "SE": 25,
        "SK": 23,
        "SI": 22,
        "ES": 21,
        "CZ": 21,
        "HU": 27,
        "CY": 19,
    },
    "ebook": {
        "BE": 6,
        "BG": 9,
        "DK": 0,
        "DE": 7,
        "EE": 9,
        "FI": 10.5,
        "FR": 5.5,
        "GR": 6,
        "IE": 0,
        "IT": 4,
        "HR": 5,
        "LV": 12,
        "LT": 9,
        "LU": 3,
        "MT": 5,
        "NL": 9,
        "NI": 0,
        "AT": 10,
        "PL": 5,
        "PT": 6,
        "RO": 5,
        "SE": 6,
        "SK": 5,
        "SI": 5,
        "ES": 21,
        "CZ": 12,
        "HU": 5,
        "CY": 1,
    },
}
const Consts = new ConstsClass();

export default Consts;
